import { UnorderedList, Link } from "@tblabs/truffle";
import { Order } from "../../../Models/Order";


export class InstructionsList extends UnorderedList
{
    constructor(order: Order)
    {
        super(
            Array.from(
                new Map(
                    order.BasketItems.filter(x => x.ProductInfo.Tutorial).map(x => [x.ProductInfo.Tutorial, new Link(x.ProductInfo.Name, x.ProductInfo.Tutorial)])
                ).values()
            )
        );

        this.TextAlignLeft().MarginTop(4);
    }
}
